<div class="vc-chips-autocomplete-with-groups-wrapper">
    <mat-form-field
        class="vc-mat-form-field vc-mat-chips-autocomplete"
        [class.vc-readonly-field]="readonly"
        [class.vc-filter-minimal-styles]="minimalStyles"
        [class.vc-autocomplete-invalid]="!valid && touched && !readonly && !disabled"
        [class.vc-no-label]="!label || label === ''"
        [class.show-description]="description !== null">
        <mat-label>{{ label }}</mat-label>
        <mat-chip-grid
            #chipGrid
            [errorStateMatcher]="errorStateMatcher"
            [disabled]="disabled"
            [required]="required"
            [attr.aria-label]="label"
            (blur)="touched = true; validate()">
            @for (val of values; track val) {
                <mat-chip-row
                    class="vc-chips-autocomplete-container-chip"
                    color="primary"
                    [removable]="canDeleteChip"
                    (removed)="onRemove(val)">
                    @if (!!prefixIconRenderer && prefixIconRenderer(val) !== '') {
                        <mat-icon
                            class="vc-chips-autocomplete-prefix"
                            [class.material-icons-outlined]="prefixIconUseOutline">
                            {{ prefixIconRenderer(val) }}
                        </mat-icon>
                    }
                    <vc-tooltip-text
                        class="vc-chips-autocomplete-container-tooltip"
                        [text]="val | textRenderer: optionRenderer"
                        [tooltipMessage]="val | textRenderer: tooltipOptionRenderer"
                        [showTooltip]="true"></vc-tooltip-text>
                    @if (!disabled && !readonly && canDeleteChip && checkIfCanDeleteChip(val)) {
                        <button matChipRemove>
                            <mat-icon>cancel</mat-icon>
                        </button>
                    }
                </mat-chip-row>
            }
            <input
                #autocompleteFilterInput
                [(ngModel)]="filterValue"
                [placeholder]="placeholder"
                [matAutocomplete]="auto"
                [matChipInputFor]="chipGrid"
                [attr.aria-invalid]="!valid && touched"
                [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                [attr.aria-describedby]="ariaDescribedBy"
                [readonly]="readonly"
                (blur)="touched = true"
                (ngModelChange)="inputValueChanges()" />
        </mat-chip-grid>
        @if (suffixIcon && (!values || values.length === 0)) {
            <mat-icon matSuffix>{{ suffixIcon }}</mat-icon>
        }
        <mat-autocomplete
            #auto="matAutocomplete"
            [hideSingleSelectionIndicator]="true"
            (optionSelected)="selectValue($event)">
            @for (group of optionGroups; track group) {
                <mat-optgroup
                    class="vc-multi-select-with-groups-sticky-header"
                    [style.display]="checkIfShowGroup(group) ? 'inline' : 'none'">
                    <vc-tooltip-text
                        class="vc-chips-autocomplete-container-tooltip"
                        [text]="group.key | textRenderer: groupRenderer"
                        style="overflow: auto"></vc-tooltip-text>
                    @for (option of group.value | search: 'name' : filterValue ?? ''; track $index) {
                        <mat-option
                            [value]="option"
                            [tabIndex]="checkIfShowOption(option) ? 0 : -1"
                            [disabled]="!checkIfShowOption(option)">
                            <vc-tooltip-text
                                [text]="option | textRenderer: optionRenderer"
                                style="overflow: auto"></vc-tooltip-text>
                            @if (!checkIfShowOption(option)) {
                                <vc-icon
                                    name="check"
                                    color="var(--button-disabled-label)"
                                    style="margin-left: auto"></vc-icon>
                            }
                        </mat-option>
                    }
                </mat-optgroup>
            }
            @if (allowAddNew && checkIfNoGroupsVisible() && filterValue) {
                <mat-option [value]="filterValue" class="vc-tag-new-tag" (click)="$event.stopPropagation()">
                    <mat-icon
                        class="material-icons-outlined"
                        fontIcon="add_circle_outlined"
                        style="
                            color: var(--button-secondary-label);
                            font-size: 20px;
                            height: 20px;
                            width: 20px;
                            margin-right: 8px;
                        "></mat-icon>
                    <vc-tooltip-text text="{{ addNewLabel }} '{{ filterValue }}'"></vc-tooltip-text>
                </mat-option>
            }
        </mat-autocomplete>
        @if (!valid && touched && !disabled && !readonly) {
            <mat-hint class="vc-error-message">
                {{ errorMessage }}
            </mat-hint>
        } @else if (!!description) {
            <mat-hint class="vc-description-message space-top-4">
                {{ description }}
            </mat-hint>
        }
    </mat-form-field>
</div>
